import styled, { css, keyframes } from 'styled-components'
import { hFlex, overlay, vFlex } from '../../../Styles/style-helpers'

export const VideoRecordEl = styled.div`
  width: 100%;
  position: relative;
`

const blink = keyframes`
50% {
  opacity: 0.5;
}`

export const RecordControlsEl = styled.div`
  ${overlay}
  ${hFlex}
  top: auto;
  bottom: 0;
  width: 100%;
  flex: 1;
  height: 5em;

  > * {
    z-index: 2;
  }

  .recordBtn {
    ${hFlex}
    color: red;
    font-size: 1.5em;
    cursor: pointer;

    svg {
      font-size: 2.5em;
    }
  }

  .recording-icon {
    ${hFlex}
    color: red;
    position: absolute;
    left: 0.5em;
    font-size: 1.5em;
    font-weight: 800;
    ${({ isPaused }) =>
      isPaused
        ? ''
        : css`
            animation: ${blink} 1s steps(5, start) infinite;
          `};
  }

  .pauseBtn,
  .stopBtn {
    color: white;
    cursor: pointer;
    transform: scale(1.5);
  }

  .stopBtn {
    transform: scale(2);
    margin-left: 1.8em;
  }
`

export const VideoEl = styled.div`
  width: 100%;
  position: relative;
  ${vFlex}
  justify-content: flex-start;

  .camera {
    width: 100%;
    position: relative;
    video {
      width: 100%;
      transform: ${({ state }) => (state !== 'RECORDED' ? 'scaleX(-1)' : '')};
    }
  }
`

export const UploadEl = styled.div`
  .upload-option {
    ${hFlex}
    justify-content: flex-start;
    position: relative;

    .uploadBtn {
      padding: 0.66em 1em;
      margin: 0 1.5em;
      color: white;
      border: none;
      border-radius: 0.25em;
      cursor: pointer;
      letter-spacing: 0.05em;
      background: #c7402d linear-gradient(196.67deg, #c7402d 0%, #ec9770 100%);
      box-shadow: 0.25em 0.25em 0.625em rgb(199 64 45 / 30%);
      transition: transform 150ms ease;
      position: relative;
      opacity: ${({ uploadingState }) =>
        uploadingState === 'SUBMITTING' ? 0 : 1};
      & > .input {
        ${overlay};
        opacity: 0;

        & > .uppy-Root {
          ${overlay}
          button {
            ${overlay};
            width: 100%;
          }
        }
      }
    }
  }

  .upload-video {
    ${vFlex}
    justify-content: flex-start;
    position: relative;
    width: 100%;
    margin-top: 1.5em;

    > * {
      width: 100%;
      padding: 0 1.5em;
      margin-bottom: 1.25em;
    }

    .uploaded-file {
      text-decoration: underline;
      font-weight: 800;
      cursor: pointer;
    }

    .enroll-message {
      textarea {
        width: 100%;
        padding: 0.25em;
      }
    }

    .action-btns {
      ${hFlex}
      justify-content: flex-start;
      > button {
        margin-right: 1em;
      }
    }
  }

  .upload-recording {
    ${vFlex}
    justify-content: flex-start;

    > * {
      width: 100%;
      margin-bottom: 1em;
    }

    .enroll-message {
      textarea {
        width: 100%;
        padding: 0.25em;
      }
    }

    .action-btns {
      ${hFlex}
      justify-content: flex-start;
      > button {
        margin-right: 1em;
      }
    }
  }
`

export const RecorderOptionsEl = styled.div`
  width: 100%;
  ${hFlex}

  ${({ state }) =>
    state === 'NOT RECORDED'
      ? css`
          justify-content: space-around;

          .inputWrapper {
            width: 30%;
            margin: 1em 0;
          }
        `
      : state === 'RECORDING' &&
        css`
          justify-content: flex-start;
          margin-top: 1em;
          > button {
            margin-left: 2em;
          }
        `}
`
